module.exports = __webpack_public_path__ + "static/MuseoSansCyrl900-5fc4144c282b595c32576b5bb11e5a9b.woff";